module.exports = __webpack_public_path__ + "static/img/sell.edb57ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sell.png
// module id = 257
// module chunks = 1